import { fetchFromAPI } from 'utils/api';

export function getBarnSheetsCompanies(params) {
  return fetchFromAPI('/barnsheets/companies', { params }).catch((errors) => {
    throw errors;
  });
}
